import { render } from "./TheUserDetails.vue?vue&type=template&id=64ebc8c2"
import script from "./TheUserDetails.vue?vue&type=script&lang=js"
export * from "./TheUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__